"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompaniesCompanyAccounts$ = exports.CompaniesCompanyAccounts$outboundSchema = exports.CompaniesCompanyAccounts$inboundSchema = void 0;
exports.companiesCompanyAccountsToJSON = companiesCompanyAccountsToJSON;
exports.companiesCompanyAccountsFromJSON = companiesCompanyAccountsFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rfcdate_js_1 = require("../../types/rfcdate.js");
const companiescompanyaccountcategory_js_1 = require("./companiescompanyaccountcategory.js");
/** @internal */
exports.CompaniesCompanyAccounts$inboundSchema = z.object({
    account_category: z.nullable(companiescompanyaccountcategory_js_1.CompaniesCompanyAccountCategory$inboundSchema),
    account_ref_day: z.nullable(z.number().int()),
    account_ref_month: z.nullable(z.number().int()),
    last_made_up_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    next_due_date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "account_category": "accountCategory",
        "account_ref_day": "accountRefDay",
        "account_ref_month": "accountRefMonth",
        "last_made_up_date": "lastMadeUpDate",
        "next_due_date": "nextDueDate",
    });
});
/** @internal */
exports.CompaniesCompanyAccounts$outboundSchema = z.object({
    accountCategory: z.nullable(companiescompanyaccountcategory_js_1.CompaniesCompanyAccountCategory$outboundSchema),
    accountRefDay: z.nullable(z.number().int()),
    accountRefMonth: z.nullable(z.number().int()),
    lastMadeUpDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    nextDueDate: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        accountCategory: "account_category",
        accountRefDay: "account_ref_day",
        accountRefMonth: "account_ref_month",
        lastMadeUpDate: "last_made_up_date",
        nextDueDate: "next_due_date",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var CompaniesCompanyAccounts$;
(function (CompaniesCompanyAccounts$) {
    /** @deprecated use `CompaniesCompanyAccounts$inboundSchema` instead. */
    CompaniesCompanyAccounts$.inboundSchema = exports.CompaniesCompanyAccounts$inboundSchema;
    /** @deprecated use `CompaniesCompanyAccounts$outboundSchema` instead. */
    CompaniesCompanyAccounts$.outboundSchema = exports.CompaniesCompanyAccounts$outboundSchema;
})(CompaniesCompanyAccounts$ || (exports.CompaniesCompanyAccounts$ = CompaniesCompanyAccounts$ = {}));
function companiesCompanyAccountsToJSON(companiesCompanyAccounts) {
    return JSON.stringify(exports.CompaniesCompanyAccounts$outboundSchema.parse(companiesCompanyAccounts));
}
function companiesCompanyAccountsFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.CompaniesCompanyAccounts$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'CompaniesCompanyAccounts' from JSON`);
}
//# sourceMappingURL=companiescompanyaccounts.js.map